import { render, staticRenderFns } from "./publicGuildItem.vue?vue&type=template&id=3c28bc17&scoped=true&"
import script from "./publicGuildItem.vue?vue&type=script&lang=js&"
export * from "./publicGuildItem.vue?vue&type=script&lang=js&"
import style0 from "./publicGuildItem.vue?vue&type=style&index=0&id=3c28bc17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c28bc17",
  null
  
)

export default component.exports